import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { WebLink } from '@news-mono/web-common'
import { calcRem, colors } from '../../__styling'

export const StyledStaticShareByLine = styled('div')({
    width: '100%',
    '& p': {
        color: colors.sevennews.dustyGray,
    },
})

export const StyledStaticByLine = styled('p')({
    fontFamily: 'HeyWow',
    fontSize: calcRem(12),
    lineHeight: calcRem(25),
    textAlign: 'left',
    span: {
        color: colors.sevennews.dustyGray,
    },
})
export const StyledStaticByLineLink = styled(WebLink)(({ theme }) => ({
    fontFamily: 'HeyWow',
    fontSize: calcRem(12),
    lineHeight: calcRem(25),
    textAlign: 'center',
    color: theme.sectionValues.primaryColor,
    textDecoration: 'none',
}))
export const StyledStaticByLineDate = styled('p')({
    fontFamily: 'HeyWow',
    fontSize: calcRem(12),
    fontWeight: 400,
    color: colors.sevennews.dustyGray,
    display: 'inline-block',
})
export const StyledStaticHr = styled('hr')({
    width: '100%',
    height: calcRem(2),
    border: 'none',
    background: tokens.sevennews.colors.palette.alto,
    margin: 0,
    padding: 0,
})
